import axios from "axios";
import { translate } from "@/i18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

const FALLBACK_ERROR = { fr: "Une erreur est survenue. Veuillez réessayer.", en: "Something went wrong. Please try again." };

export function apiError(detail, lang = "en") {
  if (detail == null) return FALLBACK_ERROR[lang] || FALLBACK_ERROR.en;
  if (typeof detail === "string") return detail.startsWith("shipping.") ? translate(detail, lang) : detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function money(n) {
  return `$${Number(n || 0).toFixed(2)}`;
}
